import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

export default function LoginAs() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get("userId"); // ✅ from query string
const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (!userId) return;
 
    const impersonate = async () => {
      try {
       const res = await axios.get(`${API_URL}/users/admin/impersonate/${userId}`);
        if (res.data.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.setItem("account_type", res.data.user.user_type);
          navigate("/dashboard");
        }
      } catch (err) {
        console.log(err);
        alert("❌ Could not impersonate user");
        navigate("/login");
      }
    };
    impersonate();
  }, [userId, navigate]);

  return <div>Logging in as user...</div>;
}
